const carouselContainer = (isDesktop) => {
    return {
        padding: isDesktop ? '1rem 2.5rem' : '1.5rem',
        'button[aria-label~="indicator"] ': {
            cursor: 'pointer',
            transition: '200ms',
            '> svg.MuiSvgIcon-root': {
                width: isDesktop ? '24px' : '15px',
                height: isDesktop ? '24px' : '15px',
            },
        },
    };
};
export { carouselContainer };
